import Agenda from "@/pages/Agenda";
import Assistentes from "@/pages/Assistentes";
import AssistenteNovo from "@/pages/AssistenteNovo";
import AssistenteEditar from "@/pages/AssistenteEditar";
import Campaigns from "@/pages/Campaigns";
import Chat from "@/pages/Chat";
import Fluxos from "@/pages/Fluxos";
import FluxoEditor from "@/pages/FluxoEditor";
import FollowUps from "@/pages/FollowUps";
import FollowUpEditor from "@/pages/FollowUpEditor";
import Contacts from "@/pages/Contacts";
import ImportarContatos from "@/pages/ImportarContatos";
import Crm from "@/pages/Crm";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Notifications from "@/pages/Notifications";
import ApiKeys from "@/pages/ApiKeys";
import AccessContacts from "@/pages/AccessContacts";
import Agency from "@/pages/Agency";
import Debug from "@/pages/Debug";
import CheckCron from "@/pages/CheckCron";
import CheckScheduledMessages from "@/pages/CheckScheduledMessages";
import DebugFollowUp from "@/pages/DebugFollowUp";
import TestError from "@/pages/TestError";
import Relatorios from "@/pages/relatorios/Relatorios";
import EntradaLeadsReport from "@/pages/relatorios/EntradaLeadsReport";
import VendasReport from "@/pages/relatorios/VendasReport";
import VendasVendedorReport from "@/pages/relatorios/VendasVendedorReport";
import TempoRespostaReport from "@/pages/relatorios/TempoRespostaReport";
import VendasCampanhaReport from "@/pages/relatorios/VendasCampanhaReport";
import PerformanceMarketingReport from "@/pages/relatorios/PerformanceMarketingReport";
import AgendamentosIaReport from "@/pages/relatorios/AgendamentosIaReport";
import * as Icons from "../components/ui/shared/Icons";
import type { PermissionArea } from "@/hooks/usePermissions";
import { ConnectionGuard } from "@/components/ui/shared/layout/ConnectionGuard";
import { BarChart3, Repeat, Workflow } from "lucide-react";

export interface NavigationItem {
  icon: React.ReactNode;
  title: string;
  /** i18n key under common namespace, e.g. menu.dashboard */
  labelKey?: string;
  path: string;
  permission?: PermissionArea;
  children?: NavigationItem[];
  comingSoon?: boolean;
}

export interface RouteConfig {
  path: string;
  element: React.ReactElement;
  permission?: PermissionArea;
  /** Fallback in pt-BR; `titleKey` wins when present. */
  title?: string;
  /** i18n key under the common namespace, e.g. routes.novoAssistente */
  titleKey?: string;
}

export const LeftNavigationData: NavigationItem[] = [
  {
    icon: <Icons.dashboard className="w-[12px] h-[12px]" />,
    title: "Dashboard",
    labelKey: "menu.dashboard",
    path: "/",
    permission: "dashboard",
  },
  {
    icon: <Icons.contact className="w-[17px] h-[17px]" />,
    title: "Contatos",
    labelKey: "menu.contatos",
    path: "/contacts",
    permission: "contatos",
  },
  {
    icon: <Icons.chat className="w-[14px] h-[14px]" />,
    title: "Chat",
    labelKey: "menu.chat",
    path: "/chat",
    permission: "chat",
  },
  {
    icon: <Icons.dashboard className="w-[12px] h-[12px]" />,
    title: "CRM",
    labelKey: "menu.crm",
    path: "/crm",
    permission: "crm",
  },
  {
    icon: <Icons.agenda className="w-[16px] h-[16px]" />,
    title: "Agenda",
    labelKey: "menu.agenda",
    path: "/agenda",
    permission: "agenda",
  },
  {
    icon: <Icons.assistance className="w-[17px] h-[17px]" />,
    title: "Assistentes",
    labelKey: "menu.assistentes",
    path: "/assistentes",
    permission: "assistentes",
  },
  {
    icon: <Workflow className="h-[17px] w-[17px]" />,
    title: "Fluxos",
    labelKey: "menu.fluxos",
    path: "/fluxos",
  },
  {
    icon: <Repeat className="h-[17px] w-[17px]" />,
    title: "Follow-ups",
    labelKey: "menu.followUps",
    path: "/follow-ups",
  },
  {
    icon: <Icons.compains className="w-[19px] h-[19px]" />,
    title: "Campanhas",
    labelKey: "menu.campanhas",
    path: "/campanhas",
    permission: "campanhas",
  },
  {
    icon: <BarChart3 className="h-[17px] w-[17px]" />,
    title: "Relatórios",
    labelKey: "menu.relatorios",
    path: "/relatorios",
    permission: "relatorios",
    comingSoon: true,
    children: [
      { icon: <span />, title: "Visão geral", labelKey: "menu.relatoriosOverview", path: "/relatorios", permission: "relatorios" },
      { icon: <span />, title: "Entrada de leads", labelKey: "menu.relatoriosEntradaLeads", path: "/relatorios/entrada-leads", permission: "relatorios" },
      { icon: <span />, title: "Vendas e perdas", labelKey: "menu.relatoriosVendas", path: "/relatorios/vendas", permission: "relatorios" },
      { icon: <span />, title: "Vendas por vendedor", labelKey: "menu.relatoriosVendasVendedor", path: "/relatorios/vendas-vendedor", permission: "relatorios" },
      { icon: <span />, title: "Tempo de resposta", labelKey: "menu.relatoriosTempoResposta", path: "/relatorios/tempo-resposta", permission: "relatorios" },
      { icon: <span />, title: "Vendas por campanha", labelKey: "menu.relatoriosVendasCampanha", path: "/relatorios/vendas-campanha", permission: "relatorios" },
      { icon: <span />, title: "Performance de Marketing", labelKey: "menu.relatoriosPerformanceMarketing", path: "/relatorios/performance-marketing", permission: "relatorios" },
      { icon: <span />, title: "Agendamentos da IA", labelKey: "menu.relatoriosAgendamentosIa", path: "/relatorios/agendamentos-ia", permission: "relatorios" },
    ],
  },
];

export const SettingsNavigationData: NavigationItem[] = [
  {
    icon: <Icons.settings className="w-[16px] h-[16px]" />,
    title: "Configurações",
    labelKey: "menu.configuracoes",
    path: "/settings",
    permission: "configuracoes",
  },
  {
    icon: <Icons.logout className="w-[16px] h-[16px]" />,
    title: "Log out",
    labelKey: "menu.logout",
    path: "/login",
  },
];

export const AuthenticatedRoutes: RouteConfig[] = [
  { path: "/", element: <Dashboard />, permission: "dashboard", title: "Dashboard", titleKey: "menu.dashboard" },
  { path: "/contacts", element: <Contacts />, permission: "contatos", title: "Contatos", titleKey: "menu.contatos" },
  { path: "/contacts/importar", element: <ImportarContatos />, permission: "contatos", title: "Importar Contatos", titleKey: "routes.importarContatos" },
  { path: "/chat", element: <ConnectionGuard><Chat /></ConnectionGuard>, permission: "chat", title: "Chat", titleKey: "menu.chat" },
  { path: "/chat/:contactId", element: <ConnectionGuard><Chat /></ConnectionGuard>, permission: "chat", title: "Chat", titleKey: "menu.chat" },
  { path: "/crm", element: <Crm />, permission: "crm", title: "CRM", titleKey: "menu.crm" },
  { path: "/crm/:contactId", element: <AccessContacts />, permission: "crm", title: "Detalhes do Contato", titleKey: "routes.detalhesContato" },
  { path: "/agenda", element: <Agenda />, permission: "agenda", title: "Agenda", titleKey: "menu.agenda" },
  { path: "/assistentes", element: <Assistentes />, permission: "assistentes", title: "Assistentes", titleKey: "menu.assistentes" },
  { path: "/assistentes/novo", element: <AssistenteNovo />, permission: "assistentes", title: "Novo Assistente", titleKey: "routes.novoAssistente" },
  { path: "/assistentes/editar/:id", element: <AssistenteEditar />, permission: "assistentes", title: "Editar Assistente", titleKey: "routes.editarAssistente" },
  { path: "/campanhas", element: <Campaigns />, permission: "campanhas", title: "Campanhas", titleKey: "menu.campanhas" },
  { path: "/relatorios", element: <Relatorios />, permission: "relatorios", title: "Relatórios", titleKey: "menu.relatorios" },
  { path: "/relatorios/entrada-leads", element: <EntradaLeadsReport />, permission: "relatorios", title: "Entrada de leads", titleKey: "menu.relatoriosEntradaLeads" },
  { path: "/relatorios/vendas", element: <VendasReport />, permission: "relatorios", title: "Vendas e perdas", titleKey: "menu.relatoriosVendas" },
  { path: "/relatorios/vendas-vendedor", element: <VendasVendedorReport />, permission: "relatorios", title: "Vendas por vendedor", titleKey: "menu.relatoriosVendasVendedor" },
  { path: "/relatorios/tempo-resposta", element: <TempoRespostaReport />, permission: "relatorios", title: "Tempo de resposta", titleKey: "menu.relatoriosTempoResposta" },
  { path: "/relatorios/vendas-campanha", element: <VendasCampanhaReport />, permission: "relatorios", title: "Vendas por campanha", titleKey: "menu.relatoriosVendasCampanha" },
  { path: "/relatorios/performance-marketing", element: <PerformanceMarketingReport />, permission: "relatorios", title: "Performance de Marketing", titleKey: "menu.relatoriosPerformanceMarketing" },
  { path: "/relatorios/agendamentos-ia", element: <AgendamentosIaReport />, permission: "relatorios", title: "Agendamentos da IA", titleKey: "menu.relatoriosAgendamentosIa" },
  { path: "/fluxos", element: <Fluxos />, title: "Fluxos", titleKey: "menu.fluxos" },
  { path: "/fluxos/novo", element: <FluxoEditor />, title: "Novo Fluxo", titleKey: "routes.novoFluxo" },
  { path: "/fluxos/editar/:id", element: <FluxoEditor />, title: "Editar Fluxo", titleKey: "routes.editarFluxo" },
  { path: "/follow-ups", element: <FollowUps />, title: "Follow-ups", titleKey: "menu.followUps" },
  { path: "/follow-ups/novo", element: <FollowUpEditor />, title: "Nova Sequência", titleKey: "routes.novaSequencia" },
  { path: "/follow-ups/editar/:id", element: <FollowUpEditor />, title: "Editar Sequência", titleKey: "routes.editarSequencia" },
  { path: "/settings", element: <Settings />, permission: "configuracoes", title: "Configurações", titleKey: "menu.configuracoes" },
  // Hub completo: acessível pelo sino do navbar, fora do menu lateral.
  { path: "/notifications", element: <Notifications />, title: "Notificações", titleKey: "menu.notificacoes" },
  // Rota secreta: gestão de Chaves de API. Fora de qualquer menu, acessível só por URL direta.
  { path: "/painel-chaves-api", element: <ApiKeys />, permission: "configuracoes", title: "Chaves de API", titleKey: "routes.chavesApi" },
  { path: "/agency", element: <Agency />, permission: "configuracoes", title: "Agência", titleKey: "routes.agencia" },
  { path: "/debug", element: <Debug />, title: "Debug" },
  { path: "/check-cron", element: <CheckCron />, title: "Check Cron" },
  { path: "/check-scheduled-messages", element: <CheckScheduledMessages />, title: "Check Mensagens Agendadas" },
  { path: "/debug-followup", element: <DebugFollowUp />, title: "Debug Follow-up" },
  { path: "/test-error", element: <TestError />, title: "Test Error" },
];
